export default __webpack_public_path__ + "static/1121-47bf3508c10c87e5cbc93c757c08ca89.gif";